/* eslint-disable indent */
import React, { useEffect } from "react";
import styles from "../EditableTag.module.css";
import Seta from "../../../Assets/images/seta.png";
import { useEditableTag } from "./EditableTagBase";
import { ToolbarComponent, CanvasComponent } from "./SharedComponents";

const EditableTag9x3 = ({ initialData, doubleTag = false }) => {
	const canvasSize = { width: 255.12, height: 85.04 };
	const {
		canvasRef,
		elements,
		setElements,
		setInitialElements,
		selectedElement,
		setSelectedElement,
		zoom,
		handleMouseDown,
		handleElementClick,
		handleMouseMove,
		handleMouseUp,
		updateElementProperty,
		deleteElement,
		handleZoomIn,
		handleZoomOut,
		handleZoomReset,
		exportToPDF,
		printPDF,
		resetToInitialState
	} = useEditableTag(canvasSize);

	useEffect(() => {
		if (initialData)
			initializeElements(initialData);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [initialData]);

	const initializeElements = (data) => {
		const newElements = [];
		let idCounter = Date.now();

		// Layout 9x3: Segue o layout do PdfHangTags9x3
		// Top container com cultura centralizada e QR Code à direita
		const topHeight = 20;

		// Cultura/Título centralizado no topo
		if (data.culture) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: data.culture,
				x: 50,
				y: 5,
				width: 120,
				height: 12,
				fontSize: 8,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "center",
				textTransform: "uppercase"
			});
		}

		// QR Code no canto superior direito
		const qrCodeX = 185;
		const qrCodeStartY = 20;

		// Textos acima do QR Code
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "CONHEÇA ORIGEM",
			x: qrCodeX,
			y: qrCodeStartY - 5,
			width: 60,
			height: 5,
			fontSize: 4,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center",
			overflow: "visible"
		});

		newElements.push({
			id: idCounter++,
			type: "text",
			content: "DESTE PRODUTO",
			x: qrCodeX,
			y: qrCodeStartY - 1,
			width: 60,
			height: 5,
			fontSize: 4,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center",
			overflow: "visible"
		});

		// QR Code
		if (data.qrCode) {
			newElements.push({
				id: idCounter++,
				type: "image",
				content: data.qrCode,
				x: qrCodeX + 15,
				y: qrCodeStartY + 3,
				width: 30,
				height: 30
			});
		}

		// Código de Barras abaixo do QR Code
		if (data.barCode) {
			newElements.push({
				id: idCounter++,
				type: "image",
				content: data.barCode,
				x: qrCodeX + 3,
				y: qrCodeStartY + 35,
				width: 48,
				height: 10,
				objectFit: "fill"
			});
		}

		// Texto "POR: SISAGRI" abaixo do código de barras
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "POR: SISAGRI",
			x: qrCodeX,
			y: qrCodeStartY + 46,
			width: 60,
			height: 5,
			fontSize: 4,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center",
			overflow: "visible"
		});

		// Lado esquerdo - informações em coluna
		const leftColumnX = 10;
		const leftColumnWidth = 170;
		let currentY = topHeight;

		// Peso Líquido Mínimo
		if (data.weight) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: `Peso Líquido Mínimo: ${data.weight}`,
				x: leftColumnX,
				y: currentY,
				width: leftColumnWidth,
				height: 6,
				fontSize: 5,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				lineHeight: 1.0,
				overflow: "visible"
			});
			currentY += 7;
		}

		// Código de Rastreio
		if (data.trackingCode) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: `Código de Rastreio: ${data.trackingCode}`,
				x: leftColumnX,
				y: currentY,
				width: leftColumnWidth,
				height: 5,
				fontSize: 5,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				lineHeight: 1.0,
				overflow: "visible"
			});
			currentY += 8;
		}

		// Produtor e Distribuidor lado a lado (row layout)
		const producerDistributorY = currentY;
		const producerX = leftColumnX;
		const producerWidth = 80;

		// Produtor
		if (data.producer) {
			const producerInfo = `Distribuído por ${data.producer.name}\n${data.producer.address}\n${data.producer.document}`;
			newElements.push({
				id: idCounter++,
				type: "text",
				content: producerInfo,
				x: producerX,
				y: producerDistributorY,
				width: producerWidth,
				height: 18,
				fontSize: 5,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				lineHeight: 1.0,
				overflow: "visible"
			});
		}

		// Distribuidor (ao lado do produtor)
		if (data.distributor) {
			const distributorX = producerX + producerWidth + 12;
			const distributorWidth = 78;
			const distributorInfo = `Destino ${data.distributor.name}\n${data.distributor.address}\n${data.distributor.document}`;
			newElements.push({
				id: idCounter++,
				type: "text",
				content: distributorInfo,
				x: distributorX,
				y: producerDistributorY,
				width: distributorWidth,
				height: 18,
				fontSize: 5,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				lineHeight: 1.0,
				overflow: "visible"
			});
		}

		// Datas abaixo do produtor/distribuidor
		currentY = producerDistributorY + 20;
		if (data.dates) {
			let dateText = "";
			if (data.dates.packaging) dateText += `Data de Embalagem: ${data.dates.packaging}\n`;
			if (data.dates.delivery) dateText += `Data de Entrega: ${data.dates.delivery}\n`;
			if (data.dates.expiry) dateText += `Data de Validade: ${data.dates.expiry}`;

			newElements.push({
				id: idCounter++,
				type: "text",
				content: dateText,
				x: leftColumnX,
				y: currentY,
				width: leftColumnWidth,
				height: 15,
				fontSize: 5,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left",
				lineHeight: 1.0,
				overflow: "visible"
			});
		}

		// Footer
		const footerY = 73;
		const footerHeight = 10;

		// Fundo preto do footer
		newElements.push({
			id: idCounter++,
			type: "footer-background",
			content: "",
			x: 0,
			y: footerY,
			width: canvasSize.width,
			height: footerHeight,
			backgroundColor: "black",
			isFooterElement: true,
			zIndex: -1
		});

		// Layout do footer
		const footerPadding = 4;
		const arrowWidth = 6;
		const spacing = 4;
		const totalArrows = 3 * arrowWidth;
		const totalSpacing = 4 * spacing;
		const availableForTexts = canvasSize.width - totalArrows - totalSpacing - (2 * footerPadding);
		const textWidth = availableForTexts / 2;

		let currentX = footerPadding;

		// Seta 1
		newElements.push({
			id: idCounter++,
			type: "image",
			content: Seta,
			x: currentX,
			y: footerY + 1,
			width: arrowWidth,
			height: 8,
			isFooterElement: true
		});
		currentX += arrowWidth + spacing;

		// Texto 1
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "PRODUTO COM ORIGEM RASTREADA",
			x: currentX,
			y: footerY + 2,
			width: textWidth,
			height: 8,
			fontSize: 4,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center",
			color: "white",
			lineHeight: 1.0,
			isFooterElement: true
		});
		currentX += textWidth + spacing;

		// Seta 2 (invertida)
		newElements.push({
			id: idCounter++,
			type: "image",
			content: Seta,
			x: currentX,
			y: footerY + 1,
			width: arrowWidth,
			height: 8,
			transform: "scaleX(-1)",
			isFooterElement: true
		});
		currentX += arrowWidth + spacing;

		// Texto 2
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "https://www.sisagri.com.br",
			x: currentX,
			y: footerY + 2,
			width: textWidth,
			height: 8,
			fontSize: 4,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center",
			color: "white",
			lineHeight: 1.0,
			isFooterElement: true
		});
		currentX += textWidth + spacing;

		// Seta 3 (invertida)
		newElements.push({
			id: idCounter++,
			type: "image",
			content: Seta,
			x: currentX,
			y: footerY + 1,
			width: arrowWidth,
			height: 8,
			transform: "scaleX(-1)",
			isFooterElement: true
		});

		setElements(newElements);
		setInitialElements(JSON.parse(JSON.stringify(newElements)));
	};

	const selectedElementData = elements.find(el => el.id === selectedElement);

	return (
		<div className={styles.editorContainer}>
			<ToolbarComponent
				selectedElementData={selectedElementData}
				updateElementProperty={updateElementProperty}
				handleZoomOut={handleZoomOut}
				handleZoomIn={handleZoomIn}
				handleZoomReset={handleZoomReset}
				zoom={zoom}
				exportToPDF={() => exportToPDF("9x3", doubleTag)}
				printPDF={() => printPDF(doubleTag)}
				resetToInitialState={resetToInitialState}
			/>

			<CanvasComponent
				canvasRef={canvasRef}
				canvasSize={canvasSize}
				zoom={zoom}
				elements={elements}
				selectedElement={selectedElement}
				setSelectedElement={setSelectedElement}
				handleMouseMove={handleMouseMove}
				handleMouseUp={handleMouseUp}
				handleMouseDown={handleMouseDown}
				handleElementClick={handleElementClick}
				deleteElement={deleteElement}
			/>
		</div>
	);
};

export default EditableTag9x3;
